module.exports = __webpack_public_path__ + "img/word.d313b934.png";